function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export default function Cancel(props) {
  const {
    fillColor,
    style,
    ...restProps
  } = props;
  const newstyle = {
    width: "auto",
    ...style
  };
  const fill = fillColor || "#000";
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, restProps, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18944,0,0,1.07567,1.33586,0.169375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.036,16.68L0.976,10.983L6.001,5.272L5.997,7.53L2.991,11.001L6.028,14.332L6.036,16.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.18944,-1.45664e-16,1.31732e-16,-1.07567,22.6759,23.7831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.036,16.68L0.976,10.983L6.001,5.272L5.997,7.53L2.991,11.001L6.028,14.332L6.036,16.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2612,0,0,2.05929,-3.14607,-9.66192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.065,10.019L18.039,10.019L18.039,11.034L6.051,11.034L6.065,10.019Z"
  })));
}